export default __webpack_public_path__ + "static/media/ci_event_pass.e8ba53bb.png";